import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { classNames } from "primereact/utils";
import { setAdminSession } from "../components/ProtectedRoute";

const ADMIN_USER = "admin";
const ADMIN_PASS = "admin@123";

export default function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || "/";

    function onSubmit(e) {
        e.preventDefault();
        setError("");
        if (username === ADMIN_USER && password === ADMIN_PASS) {
            setAdminSession();
            navigate(from === "/login" ? "/" : from, { replace: true });
        } else {
            setError("Invalid credentials. Use admin / admin@123");
        }
    }

    return (
        <div className="uc-admin-login flex align-items-center justify-content-center p-3">
            <Card
                className={classNames(
                    "uc-admin-login-card",
                    "w-full",
                    "shadow-3",
                    "overflow-hidden",
                    "border-1",
                    "surface-border",
                )}
                pt={{
                    body: { className: classNames("p-0") },
                    content: { className: classNames("p-0") },
                }}
            >
                <div className="p-4 surface-0 border-bottom-1 surface-border">
                    <div className="flex align-items-center gap-3">
                        <div className="uc-admin-brand-mark flex align-items-center justify-content-center border-round-lg">
                            <i className="pi pi-shield" />
                        </div>
                        <div>
                            <div className="text-lg font-bold text-900">SWYFT Admin</div>
                            <div className="text-600 text-sm mt-1">Sign in to continue</div>
                        </div>
                    </div>
                </div>
                <form onSubmit={onSubmit} className="p-4 p-fluid flex flex-column gap-3 surface-card">
                    {error ? <Message severity="error" text={error} className="w-full" /> : null}
                    <div className="flex flex-column gap-2">
                        <label htmlFor="user" className="font-medium text-900">
                            User ID
                        </label>
                        <InputText
                            id="user"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full"
                            autoComplete="username"
                        />
                    </div>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="pass" className="font-medium text-900">
                            Password
                        </label>
                        <Password
                            id="pass"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full"
                            inputClassName="w-full"
                            feedback={false}
                            toggleMask
                            autoComplete="current-password"
                        />
                    </div>
                    <Button type="submit" label="Sign in" icon="pi pi-sign-in" className="w-full mt-2" />
                </form>
            </Card>
        </div>
    );
}
